import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { UserDtoSchema } from '../contracts';

const _DeleteUserByIdRequestDtoSchema = z.object({
  id: z.number(),
});

const DeleteUserByIdResponseDtoSchema = UserDtoSchema;

export type DeleteUserByIdRequestDto = z.infer<
  typeof _DeleteUserByIdRequestDtoSchema
>;
export type DeleteUserByIdResponseDto = z.infer<
  typeof DeleteUserByIdResponseDtoSchema
>;

export const deleteUserById = (
  dto: DeleteUserByIdRequestDto,
  config?: AxiosRequestConfig<DeleteUserByIdRequestDto>
) => {
  return api
    .delete(`/users/${dto.id}`, config)
    .then(responseContract(DeleteUserByIdResponseDtoSchema));
};
